import React from 'react';
import { Box, Typography } from '@mui/material';

function PageTitle({ title }) {
  return (
    <Box sx={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      mb: 2,
      mt: 0
    }}>
      <Typography 
        variant="h5" 
        fontWeight="bold"
        color="secondary"
      >
        {title}
      </Typography>
    </Box>
  );
}

export default PageTitle; 